import { useContext } from 'react'
import { CarouselCtx } from './CarouselCtx'

export const useCarousel = () => useContext(CarouselCtx)
